<i18n>
{
    "ru": {
        "date_format": "Формат даты",
        "time_format": "Формат времени",
        "profile": "Профиль Компании",
        "company_settings": "Настройки компании",
        "bill_id": "Биллинг ID",
        "company_name": "Имя компании",
        "company_name_en": "Имя компании на английском",
        "company_unp": "УНП компании",
        "email_for_newsletters": "E-mail для рассылок",
        "email_for_invoices": "E-mail для актов",
        "legal_person": "Юридическое лицо",
        "company_address": "Адрес компании",
        "company_address_en": "Адрес компании на английском",
        "city_en": "Город на английском",
        "state": "Штат/область",
        "state_en": "Штат/область на английском",
        "notify_email": "Email для уведомлений",
        "site_url": "Сайт компании",
        "secret_key": "Секретный ключ",
        "notify_url": "URL для уведомлений",
        "decimal_place": "Разрядность дробной части",
        "date_format_info_title": "Параметры форматирования даты",
        "day_number": "День месяца, 2 цифры с ведущим нулём",
        "day_number_value": "от 01 до 31",
        "day_number_no_zero": "День месяца без ведущего нуля",
        "day_number_no_zero_value": "от 1 до 31",
        "day_text": "Текствое представление дня недели, 3 символа",
        "day_text_value": "от Mon до Sun",
        "day_fulltext": "Полное наименование дня недели",
        "day_fulltext_symbol": "l (строчная 'L')",
        "day_fulltext_value": "от Sunday до Saturday",
        "month_fulltext": "Полное наименование месяца, например January или March",
        "month_fulltext_value": "от January до December",
        "month_number": "Порядковый номер месяца с ведущим нулём",
        "month_number_value": "от 01 до 12",
        "month_text": "Сокращенное наименование месяца, 3 символа",
        "month_text_value": "от Jan до Dec",
        "month_number_no_zero": "Порядковый номер месяца без ведущего нуля",
        "month_number_no_zero_value": "от 1 до 12",
        "year_number": "Порядковый номер года, 4 цифры",
        "year_number_value": "Примеры: 1999, 2003",
        "time_format_info_title": "Параметры форматирования времени",
        "ante_meridiem_small": "Ante meridiem (до полудня) или Post meridiem (после полудня) в нижнем регистре",
        "ante_meridiem_value": "am или pm",
        "ante_meridiem_big": "Ante meridiem или Post meridiem в верхнем регистре",
        "ante_meridiem_big_value": "AM или PM",
        "hour_no_zero_12": "Часы в 12-часовом формате без ведущего нуля",
        "hour_no_zero_12_value": "от 1 до 12",
        "hour_no_zero_24": "Часы в 24-часовом формате без ведущего нуля",
        "hour_no_zero_24_value": "от 0 до 23",
        "hour_12": "Часы в 12-часовом формате с ведущим нулём",
        "hour_12_value": "от 01 до 12",
        "hour_24": "Часы в 24-часовом формате с ведущим нулём",
        "hour_24_value": "от 00 до 23",
        "minutes_zero_label": "Минуты с ведущим нулём",
        "minutes_value": "от 00 до 59",
        "seconds": "Секунды с ведущим нулём",
        "seconds_value": "от 00 до 59",
        "title_symbol": "Символ",
        "title_values": "Значения",
        "invoice_limitation": "Время выставления счёта (по умолчанию)",
        "max_billing_notice": "Количество напоминаний по счету",
        "public_key": "Публичный ключ WEBPAY",
        "qr_settings": "Страница QR (доп. поля)",
        "qr_customer_address": "Адрес покупателя",
        "qr_customer_name": "ФИО покупателя",
        "qr_customer_phone": "Телефонный номер покупателя",
        "qr_order_contract": "Номер договора",
        "public_offer": "Публичная оферта",
        "show_public_offer": "Включено",
        "public_offer_file": "Файл публичной оферты",
        "public_offer_accept_text": "Текст чекбокса 'Я согласен с условими доставки'"
    },
    "en": {
        "date_format": "Date format",
        "time_format": "Time format",
        "profile": "Company Profile",
        "company_settings": "Company Settings",
        "bill_id": "Billing ID",
        "company_unp": "Company TIN",
        "email_for_newsletters": "Email for Newsletters",
        "email_for_invoices": "Email for Invoices",
        "company_name": "Company name in Russian",
        "company_name_en": "Company name",
        "legal_person": "Legal person",
        "company_address": "Company address in Russian",
        "company_address_en": "Company address",
        "city_en": "Company city",
        "state": "Company state/province in Russian",
        "state_en": "Company state/province",
        "city": "Company city in Russian",
        "notify_email": "Notification email",
        "site_url": "Company site",
        "secret_key": "Secret key",
        "notify_url": "Notification URL",
        "decimal_place": "Decimal placement",
        "date_format_info_title": "Date formatting options",
        "day_number": "Day of the month, 2 digits with leading zeros",
        "day_number_value": "01 to 31",
        "day_number_no_zero": "Day of the month without leading zeros",
        "day_number_no_zero_value": "1 to 31",
        "day_text": "A textual representation of a day, three letters",
        "day_text_value": "Mon through Sun",
        "day_fulltext": "A full textual representation of the day of the week",
        "day_fulltext_symbol": "l (lowercase 'L')",
        "day_fulltext_value": "Sunday through Saturday",
        "month_fulltext": "A full textual representation of a month, such as January or March",
        "month_fulltext_value": "January through December",
        "month_number": "Numeric representation of a month, with leading zeros",
        "month_number_value": "01 to 12",
        "month_text": "A short textual representation of a month, three letters",
        "month_text_value": "Jan through Dec",
        "month_number_no_zero": "Numeric representation of a month, without leading zeros",
        "month_number_no_zero_value": "1 to 12",
        "year_number": "A full numeric representation of a year, 4 digits",
        "year_number_value": "Examples: 1999 or 2003",
        "time_format_info_title": "Time formatting options",
        "ante_meridiem_small": "Lowercase Ante meridiem and Post meridiem",
        "ante_meridiem_value": "am or pm",
        "ante_meridiem_big": "Uppercase Ante meridiem and Post meridiem",
        "ante_meridiem_big_value": "AM or PM",
        "hour_no_zero_12": "12-hour format of an hour without leading zeros",
        "hour_no_zero_12_value": "1 to 12",
        "hour_no_zero_24": "24-hour format of an hour without leading zeros",
        "hour_no_zero_24_value": "0 to 23",
        "hour_12": "12-hour format of an hour with leading zeros",
        "hour_12_value": "01 to 12",
        "hour_24": "24-hour format of an hour with leading zeros",
        "hour_24_value": "00 to 23",
        "minutes_zero_label": "Minutes with leading zeros",
        "minutes_value": "00 to 59",
        "seconds": "Seconds, with leading zeros",
        "seconds_value": "00 to 59",
        "title_symbol": "Symbol",
        "title_values": "Values",
        "invoice_limitation": "Default Invoice period",
        "max_billing_notice": "Default max invoice notices",
        "public_key": "Public key",
        "qr_settings": "QR page (additional fields)",
        "qr_customer_address": "Customer address",
        "qr_customer_name": "Customer name",
        "qr_customer_phone": "Customer phone",
        "qr_order_contract": "Order contract",
        "public_offer": "Public offer",
        "public_offer_file": "Public offer file",
        "show_public_offer": "Enabled",
        "public_offer_accept_text": "Text of the checkbox 'I accept public offer'"
    }
}
</i18n>
<template>
  <div v-loading="loading">
    <company-modal :visible.sync="showCompanyModal" />
    <!-- dashboard bloks -->
    <el-card class="company-settings">
      <el-row :gutter="50">
        <el-form
          v-if="profile"
          class="profile_form"
          :model="profile"
          ref="profileForm"
          :rules="profileRules"
          :show-message="false"
          @submit.native.prevent="saveProfile()"
        >
          <el-col :sm="24" :md="12" class="settings-profile bg_wite">
            <div class="header-setings">
              {{ $t('profile') }}:
              <span>{{ profile.billing_name }}</span>
            </div>
            <div class="header-setings_sub">
              {{ $t('bill_id') }}:
              <span>{{ profile.billing_id }}</span>
            </div>
            <el-form-item :label="$t('company_name')" prop="site_name">
              <el-input
                disabled
                size="mini"
                v-model="profile.site_name"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('company_name_en')" prop="site_name_en">
              <el-input
                disabled
                size="mini"
                v-model="profile.site_name_en"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('company_unp')" prop="company_unp">
              <el-input
                  disabled
                  size="mini"
                  v-model="profile.company_unp"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('email_for_newsletters')" prop="email_for_newsletters">
              <el-input
                  disabled
                  size="mini"
                  v-model="profile.email_for_newsletters"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('email_for_invoices')" prop="email_for_invoices">
              <el-input
                  disabled
                  size="mini"
                  v-model="profile.email_for_invoices"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('legal_person')" prop="site_legal_person">
              <el-input
                disabled
                size="mini"
                v-model="profile.site_legal_person"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('country')" prop="country_id">
              <el-select size="mini" v-model="profile.country_id" filterable>
                <el-option
                  v-for="country in countries"
                  :key="country.value"
                  :label="country.label"
                  :value="country.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('state')" prop="site_state">
              <el-input size="mini" v-model="profile.site_state"></el-input>
            </el-form-item>
            <el-form-item :label="$t('state_en')" prop="site_state_en">
              <el-input size="mini" v-model="profile.site_state_en"></el-input>
            </el-form-item>
            <el-form-item :label="$t('city')" prop="site_city">
              <el-input size="mini" v-model="profile.site_city"></el-input>
            </el-form-item>
            <el-form-item :label="$t('city_en')" prop="site_city_en">
              <el-input size="mini" v-model="profile.site_city_en"></el-input>
            </el-form-item>
            <el-form-item :label="$t('zip')" prop="site_zip">
              <el-input size="mini" v-model="profile.site_zip"></el-input>
            </el-form-item>
            <el-form-item :label="$t('company_address')" prop="site_address1">
              <el-input size="mini" v-model="profile.site_address1"></el-input>
            </el-form-item>
            <el-form-item :label="$t('company_address_en')" prop="site_address1_en">
              <el-input size="mini" v-model="profile.site_address1_en"></el-input>
            </el-form-item>
            <el-form-item :label="$t('phone')" prop="site_phone">
              <el-input size="mini" v-model="profile.site_phone"></el-input>
            </el-form-item>
            <el-form-item :label="$t('fax')" prop="site_fax">
              <el-input size="mini" v-model="profile.site_fax"></el-input>
            </el-form-item>
            <el-form-item :label="$t('notify_email')" prop="site_email">
              <el-input size="mini" v-model="profile.site_email"></el-input>
            </el-form-item>
            <el-form-item :label="$t('site_url')" prop="site_url">
              <el-input
                disabled
                size="mini"
                v-model="profile.site_url"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12">
            <h4 class="header-setings">{{ $t('company_settings') }}:</h4>

            <el-row class="seckret_key_block" :gutter="20">
              <el-col>
                <el-form-item :label="$t('secret_key')">
                  <el-input
                    size="mini"
                    v-model="profile.secret_key"
                    :disabled="!profile.secret_key_enable"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item :label="$t('notify_url')">
                  <el-input size="mini" v-model="profile.notify_url"></el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item :label="$t('grace_period')">
                  <el-input
                    type="number"
                    size="mini"
                    v-model="profile.grace_period"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item :label="$t('max_billing_notice')">
                  <el-input
                    type="number"
                    size="mini"
                    v-model="profile.max_billing_notice"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item :label="$t('invoice_limitation')">
                  <el-row>
                    <el-col :span="8">
                      <el-form-item :label="$t('days')" prop="limitation_days">
                        <el-autocomplete
                          v-model="profile.limitation_days"
                          size="mini"
                          class="input-no-padding"
                          :fetch-suggestions="daysSearch"
                        ></el-autocomplete>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                        :label="$t('hours')"
                        prop="limitation_hours"
                      >
                        <el-autocomplete
                          v-model="profile.limitation_hours"
                          size="mini"
                          class="input-no-padding"
                          :fetch-suggestions="hoursSearch"
                        ></el-autocomplete>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                        :label="$t('minutes')"
                        prop="limitation_minutes"
                      >
                        <el-autocomplete
                          v-model="profile.limitation_minutes"
                          size="mini"
                          class="input-no-padding"
                          :fetch-suggestions="minutesSearch"
                        ></el-autocomplete>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :md="12">
                <el-form-item :label="$t('decimal_place')" prop="decimal_place">
                  <el-input
                    size="mini"
                    v-model="profile.decimal_place"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="12">
                <el-form-item :label="$t('language')" prop="language_id">
                  <el-select size="mini" v-model="profile.language_id">
                    <el-option label="english" value="english"></el-option>
                    <el-option label="russian" value="russian"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="12">
                <el-form-item prop="date_format">
                  <span slot="label">
                    <el-popover trigger="hover">
                      <h4>{{ $t('date_format_info_title') }}</h4>
                      <table border="0" cellpadding="2" cellspacing="1">
                        <thead>
                          <tr>
                            <th>{{ $t('title_symbol') }}</th>
                            <th>{{ $t('title_description') }}</th>
                            <th>{{ $t('title_values') }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>d</td>
                            <td>{{ $t('day_number') }}</td>
                            <td>{{ $t('day_number_value') }}</td>
                          </tr>
                          <tr>
                            <td>j</td>
                            <td>{{ $t('day_number_no_zero') }}</td>
                            <td>{{ $t('day_number_no_zero_value') }}</td>
                          </tr>
                          <tr>
                            <td>D</td>
                            <td>{{ $t('day_text') }}</td>
                            <td>{{ $t('day_text_value') }}</td>
                          </tr>
                          <tr>
                            <td>{{ $t('day_fulltext_symbol') }}</td>
                            <td>{{ $t('day_fulltext') }}</td>
                            <td>{{ $t('day_fulltext_value') }}</td>
                          </tr>
                          <tr>
                            <td>F</td>
                            <td>{{ $t('month_fulltext') }}</td>
                            <td>{{ $t('month_fulltext_value') }}</td>
                          </tr>
                          <tr>
                            <td>m</td>
                            <td>{{ $t('month_number') }}</td>
                            <td>{{ $t('month_number_value') }}</td>
                          </tr>
                          <tr>
                            <td>M</td>
                            <td>{{ $t('month_text') }}</td>
                            <td>{{ $t('month_text_value') }}</td>
                          </tr>
                          <tr>
                            <td>n</td>
                            <td>{{ $t('month_number_no_zero') }}</td>
                            <td>{{ $t('month_number_no_zero_value') }}</td>
                          </tr>
                          <tr>
                            <td>Y</td>
                            <td>{{ $t('year_number') }}</td>
                            <td>{{ $t('year_number_value') }}</td>
                          </tr>
                        </tbody>
                      </table>

                      <span slot="reference">
                        {{ $t('date_format') }}
                        <i class="el-icon-question"></i>
                      </span>
                    </el-popover>
                  </span>
                  <el-input
                    size="mini"
                    v-model="profile.date_format"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="12">
                <el-form-item prop="time_format">
                  <span slot="label">
                    <el-popover trigger="hover">
                      <h4>{{ $t('time_format_info_title') }}</h4>
                      <table border="0" cellpadding="2" cellspacing="1">
                        <thead>
                          <tr>
                            <th>{{ $t('title_symbol') }}</th>
                            <th>{{ $t('title_description') }}</th>
                            <th>{{ $t('title_values') }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>a</td>
                            <td>{{ $t('ante_meridiem_small') }}</td>
                            <td>{{ $t('ante_meridiem_value') }}</td>
                          </tr>
                          <tr>
                            <td>A</td>
                            <td>{{ $t('ante_meridiem_big') }}</td>
                            <td>{{ $t('ante_meridiem_big_value') }}</td>
                          </tr>
                          <tr>
                            <td>g</td>
                            <td>{{ $t('hour_no_zero_12') }}</td>
                            <td>{{ $t('hour_no_zero_12_value') }}</td>
                          </tr>
                          <tr>
                            <td>G</td>
                            <td>{{ $t('hour_no_zero_24') }}</td>
                            <td>{{ $t('hour_no_zero_24_value') }}</td>
                          </tr>
                          <tr>
                            <td>h</td>
                            <td>{{ $t('hour_12') }}</td>
                            <td>{{ $t('hour_12_value') }}</td>
                          </tr>
                          <tr>
                            <td>H</td>
                            <td>{{ $t('hour_24') }}</td>
                            <td>{{ $t('hour_24_value') }}</td>
                          </tr>
                          <tr>
                            <td>i</td>
                            <td>{{ $t('minutes_zero_label') }}</td>
                            <td>{{ $t('minutes_value') }}</td>
                          </tr>
                          <tr>
                            <td>s</td>
                            <td>{{ $t('seconds') }}</td>
                            <td>{{ $t('seconds_value') }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <span slot="reference">
                        {{ $t('time_format') }}
                        <i class="el-icon-question"></i>
                      </span>
                    </el-popover>
                  </span>
                  <el-input
                    size="mini"
                    v-model="profile.time_format"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="12">
                <el-form-item :label="$t('transaction_period')" prop="transaction_period">
                  <el-select size="mini" v-model="profile.transaction_period">
                    <el-option
                        v-for="n in 10"
                        :key="n"
                        :label="n.toString()"
                        :value="n.toString()"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="profile.public_key">
              <el-col>
                <el-form-item prop="" :label="$t('public_key') + ':'">
                  <el-input
                    v-model="profile.public_key"
                    type="textarea"
                    size="medium"
                    rows="10"
                    resize="none"
                    disabled
                  ></el-input>
                  <el-row slot="label">
                    {{ $t('public_key') }}
                    <el-button size="mini" circle @click="copyKey">
                      <i class="el-icon-share"></i>
                    </el-button>
                  </el-row>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" id="qr_setting_section">
              <el-col>
                <h4 class="header-setings">{{ $t('qr_settings') }}:</h4>
                <el-form-item>
                  <el-checkbox
                    :label="$t('qr_customer_name')"
                    v-model="profile.qr_customer_name"
                  ></el-checkbox>
                </el-form-item>
                <el-form-item>
                  <el-checkbox
                    :label="$t('qr_customer_address')"
                    v-model="profile.qr_customer_address"
                  ></el-checkbox>
                </el-form-item>
                <el-form-item>
                  <el-checkbox
                    :label="$t('qr_customer_phone')"
                    v-model="profile.qr_customer_phone"
                  ></el-checkbox>
                </el-form-item>
                <el-form-item>
                  <el-checkbox
                    :label="$t('qr_order_contract')"
                    v-model="profile.qr_order_contract"
                  ></el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>

              <el-row :gutter="20" id="public_offer_section">
                  <el-col>
                      <h4 class="header-setings">{{ $t('public_offer') }}:</h4>

                      <el-form-item>
                          <el-checkbox
                              :label="$t('show_public_offer')"
                              v-model="profile.show_public_offer">
                          </el-checkbox>
                      </el-form-item>

                      <el-tabs v-if="profile.show_public_offer" v-model="publicOfferActiveTab" activeName="ru" Aclass="demo-tabs" type="border-card">
                          <el-tab-pane :label="$t('lang_abbr_ru')" name="ru">
                              <el-form-item prop="public_offer_file_ru" :label="$t('public_offer_file')">
                                  <upload-public-offer v-model="profile.public_offer_file_ru" :billing_id="profile.billing_id" lang="ru" />
                              </el-form-item>

                              <el-form-item prop="public_offer_accept_text_ru" :label="$t('public_offer_accept_text')">
                                  <el-input v-model="profile.public_offer_accept_text_ru"></el-input>
                              </el-form-item>
                          </el-tab-pane>

                          <el-tab-pane :label="$t('lang_abbr_en')" name="en">
                              <el-form-item prop="public_offer_file_en" :label="$t('public_offer_file')">
                                  <upload-public-offer v-model="profile.public_offer_file_en" :billing_id="profile.billing_id" lang="en" />
                              </el-form-item>

                              <el-form-item prop="public_offer_accept_text_en" :label="$t('public_offer_accept_text')">
                                  <el-input v-model="profile.public_offer_accept_text_en" class="public_offer_text"></el-input>
                              </el-form-item>
                          </el-tab-pane>
                      </el-tabs>
                  </el-col>
              </el-row>
          </el-col>

          <el-col class="aligner right">
            <el-button round type="primary" native-type="submit">{{
              $t('save')
            }}</el-button>
          </el-col>
        </el-form>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import apiRes from '../../core/apiRes'
import CompanyModal from './CompanyModal.vue'
import copy from 'copy-to-clipboard'
import Vue from 'vue'
import UploadPublicOffer from './UploadPublicOffer.vue'

export default {
    name: 'company',

    components: {
        'company-modal': CompanyModal,
        'upload-public-offer': UploadPublicOffer
    },

    data() {
        return {
            billingUrl: process.env.VUE_APP_BILLING_API_URL,
            headers: {
                'Authorization': `Bearer ${window.localStorage.getItem('jwt_token')}`
            },
            publicOfferActiveTab: 'ru',
            countries: [],
            showCompanyModal: false,
            oldProfile: {limitation_days: '', limitation_hours: '', limitation_minutes: ''},
            profile: null,
            profileRules: {
                site_name: {required: true, trigger: 'blur', message: ' '},
                site_name_en: {required: false},
                company_unp: {required: false, trigger: 'blur', message: ' '},
                email_for_invoices: {required: false, trigger: 'blur', message: ' '},
                site_legal_person: {required: true, trigger: 'blur', message: ' '},
                site_email: {required: true, trigger: 'blur', message: ' '},
                site_address1_en: {required: false},
                site_address1: {required: true, trigger: 'blur', message: ' '},
                site_city: {required: true, trigger: 'blur', message: ' '},
                site_city_en: {required: false},
                site_state_en: {required: false},
                site_zip: {required: true, trigger: 'blur', message: ' '},
                language_id: {required: true, trigger: 'blur', message: ' '},
                decimal: {required: true, trigger: 'blur', message: ' '},
                site_phone: {required: true, trigger: 'blur', message: ' '},
                date_format: {required: true, trigger: 'blur', message: ' '},
                time_format: {required: true, trigger: 'blur', message: ' '},
                max_billing_notice: {required: true, trigger: 'blur', message: ' '},
                grace_period: {required: true, trigger: 'blur', message: ' '},
                limitation_days: { trigger: 'change', validator: (r, v, c) => { c(/^\d+$/.test(v) && parseInt(v) >= 0 && parseInt(v) <= 71 ? undefined : new Error()) } },
                limitation_hours: { trigger: 'change', validator: (r, v, c) => { c(/^\d+$/.test(v) && parseInt(v) >= 0 && v <= parseInt(23) ? undefined : new Error()) } },
                limitation_minutes: { trigger: 'change', validator: (r, v, c) => { c(/^\d+$/.test(v) && parseInt(v) >= 0 && v <= parseInt(59) ? undefined : new Error()) } }
            },
            loading: true
        }
    },

    created() {
        this.loading = true
        apiRes.get(apiRes.profileUrl).then((data) => {
            this.loading = false
            if (data.page_vars) {
                this.profile = Object.assign({
                    limitation_days: '',
                    limitation_hours: '',
                    limitation_minutes: ''
                }, data.page_vars)
                this.countries = Object.keys(data.page_vars.country).filter(k => k !== 'selected_id').map(key => {
                    return {
                        label: key,
                        value: data.page_vars.country[key]
                    }
                })
                this.profile.country_id = this.profile.country.selected_id ? this.profile.country.selected_id : this.countries[0].value

                this.profile.qr_customer_address = this.profile.qr_customer_address === '1'
                this.profile.qr_customer_name = this.profile.qr_customer_name === '1'
                this.profile.qr_customer_phone = this.profile.qr_customer_phone === '1'
                this.profile.qr_order_contract = this.profile.qr_order_contract === '1'
                this.profile.show_public_offer = this.profile.show_public_offer === '1'

                Vue.nextTick(() => {
                    let limitation = parseInt(this.profile.invoice_limitation)
                    if (limitation > 0) {
                        this.oldProfile.limitation_days = this.profile.limitation_days = parseInt(this.profile.invoice_limitation / 60 / 24).toString()
                        this.oldProfile.limitation_hours = this.profile.limitation_hours = parseInt(this.profile.invoice_limitation / 60 % 24).toString()
                        this.oldProfile.limitation_minutes = this.profile.limitation_minutes = (this.profile.invoice_limitation % 60).toString()
                    } else {
                        this.profile.limitation_days = this.profile.limitation_hours = this.profile.limitation_minutes = '0'
                    }
                })
            }
        })
    },

    methods: {
        daysSearch (query, cb) {
            let days = [...Array(72).keys()].map(v => v.toString())
            cb((query && this.profile.limitation_days !== this.oldProfile.limitation_days ? days.filter(v => v.indexOf(query.toString()) > -1) : days).map(v => { return { value: v } }))
        },
        hoursSearch (query, cb) {
            let hours = [...Array(24).keys()].map(v => v.toString())
            cb((query && this.profile.limitation_hours !== this.oldProfile.limitation_hours ? hours.filter(v => v.indexOf(query.toString()) > -1) : hours).map(v => { return { value: v } }))
        },
        minutesSearch (query, cb) {
            let minutes = [0, 30].map(v => v.toString())
            cb((query && this.profile.limitation_minutes !== this.oldProfile.limitation_minutes ? minutes.filter(v => v.indexOf(query.toString()) > -1) : minutes).map(v => { return { value: v } }))
        },
        openModal() {
            this.showCompanyModal = true
        },
        copyKey() {
            copy(this.profile.public_key)
            this.$notify.info({message: this.$t('copied')})
        },
        saveProfile() {
            this.$refs['profileForm'].validate((valid) => {
                if (valid) {
                    this.loading = true
                    let toSend = {}
                    Object.assign(toSend, this.profile)
                    toSend.currency = toSend.currency_id
                    toSend.template = toSend.template_id
                    toSend.site_country_id = toSend.country_id
                    toSend.lexpire = toSend.login_expire
                    toSend.login_attempts = toSend.login_attempt_try
                    toSend.login_lock = toSend.login_attempt_lock
                    toSend.cexpire = toSend.cookie_expire
                    toSend.language = toSend.language_id
                    toSend.timeformat = toSend.time_format
                    toSend.dateformat = toSend.date_format
                    toSend.decimal = toSend.decimal_place
                    toSend.max_notice = toSend.max_billing_notice

                    toSend.invoice_limitation = parseInt(toSend.limitation_minutes) + (parseInt(toSend.limitation_hours) + parseInt(toSend.limitation_days) * 24) * 60

                    toSend.qr_customer_address = String(+toSend.qr_customer_address)
                    toSend.qr_customer_name = String(+toSend.qr_customer_name)
                    toSend.qr_customer_phone = String(+toSend.qr_customer_phone)
                    toSend.qr_order_contract = String(+toSend.qr_order_contract)
                    toSend.show_public_offer = +toSend.show_public_offer

                    delete toSend.public_key
                    apiRes.post(apiRes.profileUrl, toSend).then(() => {
                        this.loading = false
                    })
                }
            })
        }
    }
}
</script>

<style>
.company-settings .el-select {
  width: 100%;
}

.company-settings input[type='text'],
input[type='number'] {
  background-color: transparent;
}

.gray_block {
  padding: 30px;
  margin-left: -15px;
  margin-right: -15px;
  background: #fbfbfb;
  border-radius: 0 15px 0 0;
}

.header-setings {
  /* font-size: 18px; */
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: left;
  color: #606266;
  margin-top: 15px;
}

.header-setings_sub {
  /* font-size: 16px; */
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.31;
  letter-spacing: normal;
  text-align: left;
  color: #c1c1c1;
  margin-top: 15px;
}

.header-setings span,
.header-setings_sub span {
  /* font-size: 16px; */
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.31;
  letter-spacing: normal;
  text-align: left;
  color: #606266;
  padding-left: 10px;
}

.profile_form {
  margin-top: 30px;
}

.seckret_key_block {
  margin-top: 65px;
}

.setings_company_curency_block {
  position: relative;
}

.setings_company_curency_block h5 {
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #606266;
}

.services-list {
  margin: 0 0 0 15px;
  padding: 0;
}

.services-list > li {
  list-style: none;
  display: block;
  position: relative;
  height: 30px;
  width: 220px;
}

.services-list > li > span {
  display: block;
}

.services-text {
  /* font-size: 14px; */
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #606266;
  position: absolute;
  top: 0px;
  left: 0px;
}

.services-text-green {
  /* font-size: 14px; */
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #70ac6c;
  width: 50px;
  position: absolute;
  right: 0px;
  top: 0px;
}

#qr_setting_section .el-form-item__content {
  line-height: 14px;
}

.el-checkbox {
  margin-top: 0;
}

.el-checkbox__label {
  font-size: 12px;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: left;
  color: #c1c1c1;
  float: none;
}

.el-checkbox__inner {
  width: 16px;
  height: 16px;
  border-radius: 4px;
}

.el-checkbox__inner::after {
  height: 8px;
  left: 6px;
}

.el-checkbox__input.is-checked+.el-checkbox__label {
  color: #c1c1c1;
}

@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
  .services-list input[type='button'] {
    display: block;
    width: 100%;
    margin: 0;
    position: static;
  }
}
</style>
